/* Leaf & Synth — outside-click closing for the cart only (Horizon 4.3).
 * Desktop 4.3 opens theme-drawer as a non-modal sidebar, so there is no
 * backdrop to click. Mobile already has native modal backdrop handling.
 * Do not interfere with a nested dialog or an overlaid second drawer.
 */
(() => {
  const desktop = window.matchMedia('(min-width: 990px)');
  document.addEventListener('pointerdown', (event) => {
    if (!desktop.matches) return;
    const cart = document.getElementById('cart-drawer');
    if (!cart?.hasAttribute('open') || typeof cart.close !== 'function') return;
    const panel = cart.querySelector('dialog.theme-drawer__dialog');
    if (!panel?.open) return;

    // A click inside the drawer should never dismiss it.
    const path = event.composedPath();
    if (path.includes(panel) || panel.contains(event.target)) return;

    // Other dialogs, including cart discount/policy popups, take precedence.
    const otherDialogs = [...document.querySelectorAll('dialog[open]')].filter(d => d !== panel);
    if (otherDialogs.length > 0) return;

    // Avoid intercepting the native cart icon's toggle click.
    const outsideTarget = event.target;
    if (outsideTarget instanceof Element &&
        (outsideTarget.closest('[aria-controls="cart-drawer"]') ||
         outsideTarget.closest('[on\\:click="#cart-drawer/toggle"]'))) return;

    // Only close the topmost drawer, preserving stacked drawer behavior.
    const rank = Number(cart.style.getPropertyValue('--drawer-stack-order') || 0);
    for (const other of document.querySelectorAll('theme-drawer[open]')) {
      if (other === cart) continue;
      if (Number(other.style.getPropertyValue('--drawer-stack-order') || 0) > rank) return;
    }

    // Native ThemeDrawer.close() keeps animation and focus restoration.
    cart.close();
  }, { capture: true });
})();
